import { render, staticRenderFns } from "./wdtOrdeAction.vue?vue&type=template&id=15d1ca94&scoped=true"
import script from "./wdtOrdeAction.vue?vue&type=script&lang=js"
export * from "./wdtOrdeAction.vue?vue&type=script&lang=js"
import style0 from "./wdtOrdeAction.vue?vue&type=style&index=0&id=15d1ca94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1ca94",
  null
  
)

export default component.exports